export const ADD_COUNT = "ADD_COUNT";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
// ----------------- [ JOBS REDUCER ]
export const ADD_JOB = "ADD_JOB";
export const ADD_JOBS = "ADD_JOBS";
// ----------------- [ MEETINGS REDUCER ]
export const ADD_MEETINGS = "ADD_MEETINGS";
// ----------------- [ CHATS REDUCER ]
export const STORE_CHATS = "STORE_CHATS";
export const APPEND_CHATS = "APPEND_CHATS";
export const UPDATE_CHATS = "UPDATE_CHATS";
export const READ_CHAT = "READ_CHAT";
export const SET_MEETING = "SET_MEETING";

export const SUB_SUCCESS = "http://go2work-dev.web.app";
export const LINKEDIN_REDIRECT_URI = "https://go2work.com/callback";

export const STORE_NOTIFICATIONS = "STORE_NOTIFICATIONS";
export const APPEND_NOTIFICATIONS = "APPEND_NOTIFICATIONS";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const DECLINE_OFFER = "DECLINE_OFFER";
export const ACCEPT_OFFER = "ACCEPT_OFFER";
export const DECLINE_INTERVIEW = "DECLINE_INTERVIEW";
export const ACCEPT_INTERVIEW = "ACCEPT_INTERVIEW";
export const DATA_FETCHED = "DATA_FETCHED";
export const DATA_FETCHING = "DATA_FETCHING";
export const ACCEPT_JOB = "ACCEPT_JOB";
export const DECLINE_JOB = "DECLINE_JOB";

export const EMPLOYER_PERMISSIONS = [];

export const OPENSTREETMAP_API_URL = "https://nominatim.openstreetmap.org";

export const COMMON_EMAIL_DOMAINS = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "outlook.com",
  "icloud.com",
  "aol.com",
  "mail.com",
  "zoho.com",
  "inbox.com",
  "protonmail.com",
  "fastmail.com",
  "hushmail.com",
];

export const SUBSCRIPTION_PLANS = [
  {
    title: "go2work Standard Plan",
    key: "standard",
    identifier: "Standard Monthly",
  },
  {
    title: "go2work Premium Plan",
    key: "premium",
    identifier: "Premium Monthly",
  },
  {
    title: "go2work Pro Plan",
    key: "pro",
    identifier: "Pro Monthly",
  },
];

export const SUBSCRIPTION_PURCHASE_TYPE = {
  BUY: "buy",
  CANCEL: "cancel",
  UPGRADE: "upgrade",
};

export const PERMISSIONS = {
  jobs: "JOBS",
  job_paused: "JOB_PAUSED",
  post_job_limit: "POST_JOBS_LIMIT",
  request_to_apply_limit: "REQUEST_TO_APPLY_LIMIT",
  teammates: "TEAMMATES",
  organizations: "ORGANIZATIONS",
  subscription: "SUBSCRIPTION",
  trial: "TRIAL",
};

export const MAX_UPLOAD_SIZE = 1024 * 1024 * 10;
export const ACCEPTED_FILE_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
];

export const MAX_FILE_SIZE_MB = 5;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;